export const CONTACTS = [
    { name: "Telephone", link: "/admissions" },
    { name: "Mail", link: "/admissions" },
  ];
  export const QUICKLINKS = [
    { name: "Aims & Values", link: "/about/founder" },
    { name: "Admissions", link: "/admissions" },
    { name: "About Us", link: "/about/about-us" },
    { name: "Gallery", link: "/school-life" },
    // { name: "Prospectus Request", link: "#" },
    // { name: "Alumni", link: "#" },
  ];

  
  export const Icons = [
    { name: "logo-facebook", link: "#" },
    { name: "logo-instagram", link: "#" },
  ];